import Home from '../page/Home.vue'
//import HomeList from '../components/home/HomeList.vue'
import HomeList from './homelist.js'
import ModuleOption from './moduleOption.js'
import TeachCourse from './TeachCourse.js'
import TeachClass from './TeachClass.js'
// 试题库 start -----------------------------------
import Topiclibrary from './topiclibrary.js'
//共享题库
import ShareTopiclibrary from './sharetopiclibrary.js'
// 试题展示
import Topiclibraryview from './topiclibraryview.js'
// 共享试题展示
import ShareTopiclibraryview from './sharetopiclibraryview.js'
// 试题库 end -----------------------------------
// 章管理 start -----------------------------------
import Chapter from './chapter.js'
// 节管理 start -----------------------------------
import Section from './section.js'
// 章节管理 start -----------------------------------
import ChapterSection from './chapterSection.js'

// 试题库 end -----------------------------------
// 试卷库 start -----------------------------------
import Paperlibrary from './paperlibrary.js'
import SmartPaperlibrary from './SmartPaperlibrary.js'

// 练习库 start -----------------------------------
import Practice from './practice.js'
//练习库详情
import Practiceview from './practiceview.js'
// 练习库推送日志 start -----------------------------------
import PracticePushLog from './PracticePushLog.js'
//安排测评
import EditPaperlibrary from './editPaperlibrary'
// 试卷展示
import Paperlibraryview from './paperlibraryview.js'
// 试卷库 end -----------------------------------
// 测验报告 start -----------------------------------
import Reportlibrary from './reportlibrary.js'
// 测验报告展示
import Reportlibraryview from './reportlibraryview.js'
// 考试报告展示
import Reportcheckpaper from './reportcheckpaper.js'
// 班级考试报告展示
import Reportcheckpaperclassmaster from './reportcheckpaperclassmaster.js'
// 学校考试报告展示
import Reportcheckpapereducationaladministrator from './reportcheckpapereducationaladministrator.js'
// 考试报告讲解
import Reportexplainpaper from './reportexplainpaper.js'
// 测验报告展示
import Reportreadpaper from './reportreadpaper.js'
// 批量阅卷
import Reportbatchreadpaper from './reportbatchreadpaper.js'
// 测验报告 end -----------------------------------
// 班主任查看考试报告 start-----------------------
import ClassMasterReportLibrary from './classmasterreportlibrary.js'
import ReportLibraryClassMasterView from './reportlibraryclassmasterview.js'
import ReportExplainPaperClassMaster from './reportexplainpaperclassmaster.js'
// 班主任查看考试报告 end-----------------------
// 教务管理员查看考试报告 start-----------------------
import EducationalAdministratorReportLibrary from './educationaladministratorreportlibrary.js'
import ReportLibraryEducationalAdministratorView from './reportlibraryeducationaladministratorview.js'
import ReportExplainPaperEducationalAdministrator from './reportexplainpapereducationaladministrator.js'
// 教务管理员查看考试报告 end-----------------------
// 读取是班级管理classroom
import Classroom from './classroom.js'
// 学生管理
import Editstudent from './editstudent.js'
// 读取是个人信息personal
import Personal from './personal.js'
// 读取是个人信息personal
import GameUser from './gameUser.js'
import ExercisesBank from './admin/exercisesBank.js'
import RecordProblem from './admin/recordProblem.js'
import EditExercise from './admin/editExercise.js'
import EditPaperExercise from './admin/editPaperExercise.js'
// 学生答题
// 查询某学生所在的班级已推送的练习库
import Examination from './student/examination.js'
import PaperView from './admin/paperView.js'
import EditExam from './admin/editExam.js'
import ModifyExam from './admin/modifyExam.js'
import GroupPaper from './admin/groupPaper.js'
import SchoolPaper from './schoolPaper.js'
import SchoolBank from './schoolBank.js'
// import TxtBookChapter from './admin/txtBookChapter.js'
export default {
  path: '/home/homelist',
  component: Home,
  children: [
    ModuleOption,
    // 学测主页
    HomeList,
    // 试题库
    Topiclibrary,
    // 试题展示
    Topiclibraryview,
    //共享试题展示
    ShareTopiclibraryview,
    //共享题库
    ShareTopiclibrary,
    // 试卷库
    Paperlibrary,
    // 试卷展示
    Paperlibraryview,
    // 测验报告
    Reportlibrary,
    //测验报告展示
    Reportlibraryview,
    //查看试卷
    Reportcheckpaper,
    //查看班级成绩
    Reportcheckpaperclassmaster,
    //查看学校成绩
    Reportcheckpapereducationaladministrator,
    //考试报告讲解
    Reportexplainpaper,
    // 阅卷
    Reportreadpaper,
    // 批量阅卷
    Reportbatchreadpaper,
    // 班主任查看考试成绩
    ClassMasterReportLibrary,
    // 班主任查看考试详细
    ReportLibraryClassMasterView,
    // 班主任查看考试，讲解
    ReportExplainPaperClassMaster,
    // 教务管理员查看学校考试成绩
    EducationalAdministratorReportLibrary,
    // 教务管理员查看考试详细
    ReportLibraryEducationalAdministratorView,
    // 教务管理员查看考试，讲解
    ReportExplainPaperEducationalAdministrator,
    // 班级管理
    Classroom,
    // 学生管理
    Editstudent,
    // 个人信息
    Personal,
    // 成绩展示
    GameUser,
    //章管理
    Chapter,
    //节管理
    Section,
    //任课课程
    TeachCourse,
    //任课班级
    TeachClass,
    //章节管理
    ChapterSection,
    //安排测评
    EditPaperlibrary,
    //练习库
    Practice,
    //练习库推送日志
    PracticePushLog,
    //练习库详情
    Practiceview,
    //智能组卷
    SmartPaperlibrary,
    //修改考试信息
    ModifyExam,

    //学生答题
    //获取练习库
    Examination,
    //试题库 编辑试题
    ExercisesBank,
    // 试题库录题
    RecordProblem,
    //试卷详情
    PaperView,
    //安排测评
    EditExam,
    GroupPaper,
      // 编辑试题
      EditExercise,
    //学校试卷
    SchoolPaper,
    //学校题库
    SchoolBank,
    //题库章节
    // TxtBookChapter,
    //编辑试卷试题
    EditPaperExercise
  ]
}



// WEBPACK FOOTER //
// ./src/router/home.js